import React, { Component } from 'react';
import { Table } from 'antd';
import PreviewModal from './PreviewModal';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import Filter from './Filter';

class SSUlog extends Component {
    state = {
        sortParams: {},
        searchParams: {},
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
        },
        imgUrl: '',
        loading: false,
    }

    componentDidMount() {
        this.loadData();
    }

    search = params => {
        const { pagination } = this.state;
        const searchParams = { ...params };
        this.setState({
            searchParams,
            pagination: {
                ...pagination,
                current: 1,
            }
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        const url = API_URL.hospital.exportSsuMemberList;
        ExportUtil.export({ ...searchParams }, null, url);
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.querySsuMemberListForSSUlog,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    pagination,
                    loading: false,
                    data: data.datas,
                });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { curRole } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const columns = [];
        columns.push({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '医院名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
        }, {
            title: '省份',
            dataIndex: 'hospitalProvince',
            key: 'hospitalProvince',
        }, {
            title: '城市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',
        }, {
            title: '医院主管',
            dataIndex: 'hospitalChargeUser',
            key: 'hospitalChargeUser',
        })
        if (!isCRC) {
            columns.push({
                title: '与津石是否有合作',
                dataIndex: 'isCooperation',
                key: 'isCooperation',
                width: 120,
            })
        }
        columns.push( {
            title: '数据填写率',
            dataIndex: 'completedRate',
            key: 'completedRate',
            width: 120,
        }, {
            title: '最近更新时间',
            dataIndex: 'createTimeShow',
            key: 'createTimeShow',
            width: 105,
        }, {
            title: '最近更新者',
            dataIndex: 'createUserName',
            key: 'createUserName',
            width: 105,
            render: (text, record) => {
                const { createUserCode } = record;
                //人员ID为0的日志无工号（系统自动产生，后端返回"自动更新"），不显示空括号
                return (
                    text ? (createUserCode ? `${text}(${createUserCode})` : text) : ''
                )
            },
        }, {
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            width: 100,
            render: (text, record) => {
                const { ssuStructureLogId } = record;
                return (
                    <a disabled={!ssuStructureLogId} onClick={() => this.showUpdateDeatailModal(record)}>查看更新明细</a>
                )
            }
        });
        return columns
    }

    getDataSource = () => {
        const { data, pagination } = this.state;
        const { current, pageSize } = pagination;
        const dataSource = (data || []).map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
            clearArry: false,
        }, () => {
            this.loadData();
        });
    }

    showUpdateDeatailModal = record => {
        this.previewModalRef.show(record);
    }

    updateImgUrl = (imgUrl) => {
        this.setState({ imgUrl });
    }

    render() {
        const { imgUrl, loading, pagination, searchParams } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='detail' />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                    />
                    <Table
                        columns={this.getColumns()}
                        dataSource={this.getDataSource()}
                        rowKey={record => record.index}
                        loading={loading}
                        scroll={{ x: 585 }}
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                    {
                        imgUrl &&
                        <div className="flow_mask">
                            <div className="flow_content">
                                <div className="flow_close" onClick={() => this.updateImgUrl('')}>×</div>
                                <div className="flow_body">
                                    <img className="large_img" src={imgUrl} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <PreviewModal ref={el => this.previewModalRef = el} params={searchParams} updateImgUrl={this.updateImgUrl} />
            </div>
        );
    }
}

export default SSUlog;


// WEBPACK FOOTER //
// ./src/components/hospital/ssuLog/index.js